import { apiClient } from './client';
import type { SyncResponse } from '@/types';

export interface SyncJobStatus {
  syncJob: {
    running: boolean;
    schedule: string;
  };
  cleanupJob: {
    running: boolean;
    schedule: string;
  };
}

export const syncAPI = {
  triggerSync: () =>
    apiClient.post<SyncResponse>('/sync/google-sheets'),

  triggerCarSync: () =>
    apiClient.post<SyncResponse>('/sync/cars'),

  getLastSync: () =>
    apiClient.get('/sync/last'),

  getSyncHistory: (page = 1, limit = 20) =>
    apiClient.get('/sync/history', { params: { page, limit } }),

  getSyncStatus: (syncId: number) =>
    apiClient.get(`/sync/status/${syncId}`),

  stopSync: () =>
    apiClient.post('/sync/stop'),

  startSync: () =>
    apiClient.post('/sync/start'),

  getJobStatus: () =>
    apiClient.get<{ success: boolean; data: SyncJobStatus }>('/sync/job-status'),
};